import Cookies from "./Cookies";
import hasClass from "../functions/hasClass";

export default class ThemeChoose {
    tabs: any[];
    cookies: Cookies;

    constructor(tabNavigation: string) {
        this.tabs = Array.from(
            document.querySelectorAll(tabNavigation + " .tab")
        );
        this.cookies = new Cookies();
        if (this.tabs != null) {
            this.onClickTab();
        }
    }

    private onClickTab() {
        this.tabs.forEach((element: HTMLElement, index: number) => {
            element.addEventListener("click", () => {
                this.clearActiveClass(this.tabs);
                element.classList.add("active");
                this.changeTheme(element);
            });
        });
    }

    private changeTheme(element: HTMLElement) {
        let html = document.querySelector("html");
        let theme = element.dataset.theme;

        html.className = `theme--${theme}`;
        this.cookies.set("theme", theme, 3650);
    }

    private clearActiveClass(elements: HTMLElement[]) {
        elements.forEach(element => {
            element.classList.remove("active");
        });
    }
}



// WEBPACK FOOTER //
// ./src/ts/classes/ThemeChoose.ts